// Investment steps
// Investment steps
export const INVESTMENT_AGREEMENT = 1
export const PAYMENT_CONFIRMATION = 2
export const INVESTMENT_REVIEW = 3
export const INVESTMENT_APPROVAL = 4

export const INVESTMENT_IN_PROGRESS = 1
export const INVESTMENT_REQUEST = 1.5
export const INVESTMENT_EXECUTION = 4

// Withdrawal steps

export const WITHDRAWAL_IN_PROGRESS = 1
export const ORDER_PLACED = 1.5
export const WITHDRAWAL_EXECUTION = 4

// Request callback phone number
export const CREDIBILA_SUPPORT_PHONE_NUMBER = '971509338517'
